import { Component } from '@angular/core';

@Component({
    selector: 'app-ashgrid-appellation',
    templateUrl: './ashgrid-appellation.component.html',
    styleUrls: ['./ashgrid-appellation.component.scss'],
    standalone: false
})
export class AshgridAppellationComponent {

}
